import { render } from "./DeviceSettings.vue?vue&type=template&id=d7d6f534"
import script from "./DeviceSettings.vue?vue&type=script&lang=js"
export * from "./DeviceSettings.vue?vue&type=script&lang=js"

import exportComponent from "/home/salah/dev/yoda-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__